export const TKeyHeader = {
  HEADER_CTA_FREE_TRIAL: "HEADER_CTA_FREE_TRIAL",
} as const;
